<div class="container-fluid" style=" padding-right: 0px; padding-left: 0px">
  <app-nav-menu></app-nav-menu>
</div>
<div class="container" id="desktop">
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:2.6em; font-weight:bold">
      Contact Information
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 mt-1" style="font-size:2.0em">
      Notice Administrator
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-bordered">
      <tbody>
        <tr>
          <td style="font-weight:bold; vertical-align:middle; width:25%">
            <img class="brand__logo" src="../../../assets/images/ab-data-logo.png" alt="">
          </td>
          <td style="vertical-align: middle; width: 75%">
            <b>GoodRx Data Disclosure Settlement</b><br />
            c/o A.B. Data, Ltd.<br />
            PO Box 173138<br />
            Milwaukee, WI 53217<br />
            <a href="mailto:info@goodrxprivacysettlement.com" style="color:#006cDb">info@goodrxprivacysettlement.com</a><br />
            Toll Free: 1-877-888-9232
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row mt-4">
    <div class="col-md-12" style="font-size:2.0em">
      Class Counsel
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-bordered">
      <tbody>
        <tr>
          <td style="font-weight:bold; vertical-align:middle; width:25%">
            <img class="brand__logo" src="../../../assets/images/LogoLowey.png" alt="">
          </td>
          <td style="vertical-align:middle; width:75%">
            <b>Christian Levis</b><br />
            LOWEY DANNENBERG, P.C.<br />
            44 South Broadway<br />
            Suite 1100<br />
            White Plains, NY 10601<br />
          </td>
        </tr>
        <tr>
          <td style="font-weight:bold; vertical-align:middle; width:25%">
            <img class="brand__logo" src="../../../assets/images/BFishlogo.png" alt="">
          </td>
          <td style="vertical-align:middle; width:75%">
            <b>L. Timothy Fisher</b><br />
            BURSOR &amp; FISHER, P.A.<br />
            1990 North California Blvd., 9th Floor<br />
            Walnut Creek, CA 94596<br />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="container" id="mobile">
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:2.0em; font-weight:bold">
      Contact Information
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-md-12 mt-1" style="font-size:1.6em">
      Notice Administrator
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-bordered">
      <tbody>
        <tr>
          <td style="font-weight:bold; vertical-align:middle; width:25%">
            <img class="brand__logo" src="../../../assets/images/ab-data-logo.png" alt="">
          </td>
          <td style="vertical-align: middle; width: 75%; font-size: .8em">
            <b>GoodRx Data Disclosure Settlement</b><br />
            c/o A.B. Data, Ltd.<br />
            PO Box 173138<br />
            Milwaukee, WI 53217<br />
            <a href="mailto:info@goodrxprivacysettlement.com" style="color:#006cDb">info@goodrxprivacysettlement.com</a><br />
            Toll Free: 1-877-888-9232
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.6em">
      Class Counsel
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-bordered">
      <tbody>
        <tr>
          <td style="font-weight:bold; vertical-align:middle; width:25%">
            <img class="brand__logo" src="../../../assets/images/LogoLowey.png" alt="">
          </td>
          <td style="vertical-align: middle; width: 75%; font-size: .8em">
            <b>Christian Levis</b><br />
            LOWEY DANNENBERG, P.C.<br />
            44 South Broadway<br />
            Suite 1100<br />
            White Plains, NY 10601<br />
          </td>
        </tr>
        <tr>
          <td style="font-weight:bold; vertical-align:middle; width:25%">
            <img class="brand__logo" src="../../../assets/images/BFishlogo.png" alt="">
          </td>
          <td style="vertical-align: middle; width: 75%; font-size: .8em">
            <b>L. Timothy Fisher</b><br />
            BURSOR &amp; FISHER, P.A.<br />
            1990 North California Blvd., 9th Floor<br />
            Walnut Creek, CA 94596<br />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>




